export default __webpack_public_path__ + "static/media/icons-trip-48-px.a27665bb.svg";